import React from "react"
import styles from "./message.module.css"

const DivisionMessage = ({ text, internal = false }) => {
    return (
        <div className={`${styles.division} ${internal ? styles.internal : ''}`}>
            <span>{text}</span>
        </div>
    )
}

export default DivisionMessage